import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Icon / 20x20 / Close",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M5 15L15 5M5 5L15 15",
			stroke: "",
			strokeWidth: 1.4,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgClose;
